import React from 'react'
import { bezier, simpleLine, cableCanBeSelected } from '../../helpers/helpers'
import cablesPlus from '../../data/cables_network'
import cables from '../../data/cables_cables'
import cablesCapa from '../../data/cables_capacity'


const CableTramo = ({ id, d, data, cableHover }) => {
  return (
    <g className={`cable-tramos `} key={`cable-tramos ${d}`}>
      <path key={`Ctr-${id}`} className="tramo line " data-ga-cable = { data.name } d={d} />
      <path
        key={`Ctra-${id}`}
        data-ga-cable = { data.name }
        className={cableCanBeSelected(data.name) ? 'line invisible tramo-action' : 'line invisible'}
        d={d}
        id={data.name}
        onMouseEnter={e => cableHover(true, data.name, e.clientX, e.clientY)}
        onMouseLeave={e => cableHover(false, '', -100, -100)}
      />
    </g>
  )
}

const Cables = ({ selected, cableHover, p, mobile }) => {
  const dataCables =
    selected.layer === 'network' ? cablesPlus : selected.layer === 'cables' ? cables : selected.layer === 'capacity' ? cablesCapa : []
  const AllCables = dataCables.map((d, i) => {
    const tramos =
      d.geometry.type === 'MultiLineString' ? (
        d.geometry.coordinates.map((data, id) => (
          <CableTramo
            key={'tr-' + d.name + '-' + id}
            d={mobile ? simpleLine(p)(data) : bezier(p)(data)}
            id={i}
            data={d}
            cableHover={cableHover}
          />
        ))
      ) : (
        <CableTramo
          key={'tr-' + d.name}
          d={mobile ? simpleLine(p)(d.geometry.coordinates) : bezier(p)(d.geometry.coordinates)}
          id={i}
          data={d}
          cableHover={cableHover}
        />
      )
    return (
      <g
        key={'cable-' + i}
        className={
          'cable ' + d.codename + (selected.type === 'cable' ? (d.name === selected.data.name ? ' selected' : ' no-selected') : '')
        }>
        {tramos}
      </g>
    )
  })

  return <>{AllCables}</>
}

export default Cables
